// extracted by mini-css-extract-plugin
export default {"recommendedFitContainer":"Jfa-z","linkStyleCopy":"Kfa-z","updatedSizingPrediction":"Lfa-z","recommendedSize":"Mfa-z","recommendedSizeCopy":"Nfa-z"};